<div class="report-popup-container">
  <div class="popup-header">
    <h2>Select Report</h2>
    <mat-icon class="close-btn" (click)="closeModal()">close</mat-icon>
  </div>

  <div class="search-container">
    <input type="text" placeholder="Search vessel name..." [formControl]="searchControl" class="search-input" />
  </div>

  <form [formGroup]="reportTypeForm" (ngSubmit)="onSubmit()">
    <div class="popup-body">
      <!-- Loader -->
      <div *ngIf="isLoading" class="loading-area">
        <div class="loader-bar"></div>
        <p class="loading-text">Fetching pending reports...</p>
      </div>

      <ng-container *ngIf="!isLoading && filteredVessels.length > 0; else noData">
        <div *ngFor="let vessel of filteredVessels" class="vessel-container">
          <div class="vessel-header" (click)="toggleDropdown(vessel)">
            <span>{{ vessel.vesselName }} ({{ vessel.reports.length }})</span>
            <mat-icon>
              {{ vessel.showReports ? "expand_less" : "expand_more" }}
            </mat-icon>
          </div>

          <div *ngIf="vessel.showReports" class="report-list">
            <label *ngFor="let report of vessel.reports" class="report-item"
              [class.selected-report]="selectedReport?.id === report.id">
              <input type="radio" name="reportSelection" (change)="onRadioChange(report)"
                [checked]="selectedReport?.id === report.id" />

              <div class="report-details">

                <span><strong>Name:</strong> {{ report.vesselName }}</span>

                <span><strong>IMO:</strong> {{ report.vesselIMO }}</span>

                <span>
                  <strong>JSON Time:</strong>   
                  {{ report.jsonCreatedAt | date: "MMM d, y HH:mm" }}
                </span>

                <span>
                  <strong>Received Time:</strong>
                  {{ report.emailReceivedAt | date: "MMM d, y HH:mm" }}
                </span>

                <span>
                  <strong>Version:</strong>
                  {{ report.version }}
                </span>

                <span>
                  <strong>Event:</strong> {{ report.event }}
                </span>

                <span *ngIf="report.error_mail_drafted" class="badge bg-warning text-dark ms-2" style="font-size: 11px; padding: 3px 6px;">
                  ✉ Mail Drafted: {{ report.error_mail_drafted_at | date: "MMM d, HH:mm" }}
                </span>

              </div>
            </label>
          </div>
        </div>
      </ng-container>

      <ng-template #noData>
        <p *ngIf="!isLoading" class="no-data">No pending reports available.</p>
      </ng-template>
    </div>

    <div class="button-row">
      <button type="submit" class="btn submit-btn d-flex align-items-center justify-content-center"
        [disabled]="!selectedReport || isSubmitting">
        <mat-spinner *ngIf="isSubmitting" diameter="18" class="me-2"></mat-spinner>

        {{ isSubmitting ? "Submitting..." : "Submit" }}
      </button>

      <button type="button" class="btn cancel-btn" (click)="closeModal()">
        Cancel
      </button>
    </div>
  </form>
</div>